<template>
  <div class="cart-empty-container">
    <div class="flex-center empty-body">
      <img src="@/assets/emptycart.png" class="img-empty" />
      <span class="empty-text">Your cart is empty</span>
    </div>
    <gradient-button class="cta-bottom" title="Continue Shopping" @onClick="onContinueShopping" />
  </div>
</template>
<script>
import GradientButton from "@/components/GradientButton";
export default {
  name: "CartEmpty",
  components: {
    GradientButton
  },
  methods: {
    onContinueShopping() {
      this.$router.back();
    }
  }
};
</script>
<style lang="scss" scoped>
.cart-empty-container {
  display: flex;
  flex: 1;
  flex-direction: column;
  position: absolute;
  top: 50px;
  bottom: 0;
  left: calc(50% - 300px);
  right: calc(50% - 300px);
  background-color: white;
  .empty-body {
    flex-direction: column;
    flex: 1;
    .img-empty {
      width: 292px;
      height: auto;
    }
    .empty-text {
      font-family: "SFProText-Semibold", -apple-system;
      font-weight: 600;
      font-size: 20px;
      color: #aaaaaa;
      margin-top: 30px;
    }
  }
  .cta-bottom {
    margin: 0 70px 30px 70px;
  }
  @media only screen and (max-width: 600px) {
    .cart-empty-container {
      left: 0;
      right: 0;
      .cta-bottom {
        margin: 0 20px 30px 20px;
      }
    }
  }
}
</style>